import React, { useState, useEffect, useRef, useContext, createContext } from "react";
import Drawer from "@mui/material/Drawer";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { ComposedChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";
import apiClient from "./utils/apiClient";
import { CadmusLoop } from "./utils/cadmusLoop";
import { useMobile } from "./hooks/useMobile";

// TEMP: Payment method + API Tokens tijdelijk verborgen voor alle rollen (op verzoek).
// Zet terug op true om weer zichtbaar te maken voor Admin/SuperAdmin.
const SHOW_PAYMENT_AND_TOKENS = false;

const SleepCtx = createContext(false);
// Telefoon: schermvullend, kleinere marges (alleen via useMobile().isPhone)
const PhoneCtx = createContext(false);
const sl = {
  drawerBg:    "#111111",
  cardBg:      "rgba(255,255,255,0.04)",
  cardBorder:  "rgba(255,255,255,0.08)",
  textPrimary: "rgba(255,255,255,0.9)",
  textSecond:  "rgba(255,255,255,0.4)",
  textMuted:   "rgba(255,255,255,0.25)",
  inputBg:     "rgba(255,255,255,0.06)",
  inputBorder: "rgba(255,255,255,0.12)",
  btnBg:       "rgba(255,255,255,0.08)",
  btnBorder:   "rgba(255,255,255,0.12)",
  separator:   "rgba(255,255,255,0.06)",
};

// ── Icons ─────────────────────────────────────────────────────────────────────
function CredentialsIcon() {
  return (
    <div style={{ display: "flex", width: "24px", height: "24px", alignItems: "center", justifyContent: "center", borderRadius: "4px", background: "#6C48D8", flexShrink: 0 }}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.666504 3.33341C0.666504 2.96523 0.964984 2.66675 1.33317 2.66675H14.6665C15.0347 2.66675 15.3332 2.96523 15.3332 3.33341V12.6667C15.3332 13.0349 15.0347 13.3334 14.6665 13.3334H1.33317C0.964984 13.3334 0.666504 13.0349 0.666504 12.6667V3.33341ZM8.6665 5.33341V6.66675H12.6665V5.33341H8.6665ZM11.9998 8.00008H8.6665V9.33342H11.9998V8.00008ZM6.99984 6.66675C6.99984 5.74627 6.25364 5.00008 5.33317 5.00008C4.4127 5.00008 3.6665 5.74627 3.6665 6.66675C3.6665 7.58721 4.4127 8.33342 5.33317 8.33342C6.25364 8.33342 6.99984 7.58721 6.99984 6.66675ZM5.33317 9.00008C4.0445 9.00008 2.99984 10.0447 2.99984 11.3334H7.6665C7.6665 10.0447 6.62184 9.00008 5.33317 9.00008Z" fill="white"/>
      </svg>
    </div>
  );
}

function PaymentIcon() {
  return (
    <div style={{ display: "flex", width: "24px", height: "24px", alignItems: "center", justifyContent: "center", borderRadius: "4px", background: "#6C48D8", flexShrink: 0 }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M1.33643 5.99976H14.0031C14.3713 5.99976 14.6698 6.29823 14.6698 6.66642V13.3331C14.6698 13.7013 14.3713 13.9998 14.0031 13.9998H2.00309C1.63491 13.9998 1.33643 13.7013 1.33643 13.3331V5.99976ZM2.00309 1.99976H12.0031V4.66642H1.33643V2.66642C1.33643 2.29823 1.63491 1.99976 2.00309 1.99976ZM10.0031 9.3331V10.6664H12.0031V9.3331H10.0031Z" fill="white"/>
      </svg>
    </div>
  );
}

function ApiTokenIcon() {
  return (
    <div style={{ display: "flex", width: "24px", height: "24px", alignItems: "center", justifyContent: "center", borderRadius: "4px", background: "#6C48D8", flexShrink: 0 }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M6.66668 13.3333C2.98477 13.3333 0 10.3486 0 6.66663C0 2.98477 2.98477 0 6.66668 0C10.3485 0 13.3333 2.98477 13.3333 6.66663C13.3333 10.3486 10.3485 13.3333 6.66668 13.3333ZM6.66668 3.83824L3.83824 6.66663L6.66668 9.4951L9.49508 6.66663L6.66668 3.83824Z" fill="white"/>
      </svg>
    </div>
  );
}

function PresentationIcon() {
  return (
    <div style={{ display: "flex", width: "24px", height: "24px", alignItems: "center", justifyContent: "center", borderRadius: "4px", background: "#6C48D8", flexShrink: 0 }}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.33317 2.66675H14.6665C15.0347 2.66675 15.3332 2.96523 15.3332 3.33341V10.6667C15.3332 11.0349 15.0347 11.3334 14.6665 11.3334H9.33317V12.6667H11.3332V14.0001H4.6665V12.6667H6.6665V11.3334H1.33317C0.964984 11.3334 0.666504 11.0349 0.666504 10.6667V3.33341C0.666504 2.96523 0.964984 2.66675 1.33317 2.66675ZM1.99984 4.00008V10.0001H13.9998V4.00008H1.99984ZM6.6665 5.33341L10.6665 7.00008L6.6665 8.66675V5.33341Z" fill="white"/>
      </svg>
    </div>
  );
}

function SwitchOrgIcon() {
  return (
    <div style={{ display: "flex", width: "24px", height: "24px", alignItems: "center", justifyContent: "center", borderRadius: "4px", background: "#6C48D8", flexShrink: 0 }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4.66667 1.33325L1.33333 4.66659L4.66667 7.99992" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.33333 4.66675H10.6667C12.1394 4.66675 13.3333 5.86068 13.3333 7.33341C13.3333 8.28756 12.834 9.12483 12.0833 9.59692" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.3333 14.6666L14.6667 11.3333L11.3333 7.99992" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6667 11.3333H5.33333C3.86057 11.3333 2.66667 10.1394 2.66667 8.66659C2.66667 7.71244 3.16601 6.87517 3.91667 6.40308" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}

function InsightsIcon() {
  return (
    <div style={{ display: "flex", width: "24px", height: "24px", alignItems: "center", justifyContent: "center", borderRadius: "4px", background: "#6C48D8", flexShrink: 0 }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10.0775 3.9174L14 2.34904V13.3334H2V2.88224L6.07813 1.25073L10.0775 3.9174ZM3.33333 3.78459V8.15568L5.91992 6.60425L9.97853 7.95708L12.6667 6.88161V4.31779L9.92187 5.41609L5.92187 2.74878L3.33333 3.78459Z" fill="white"/>
      </svg>
    </div>
  );
}

function CloseIcon() {
  const sleeping = useContext(SleepCtx);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8.00045 7.05767L11.3003 3.75781L12.2431 4.70062L8.94325 8.00047L12.2431 11.3003L11.3003 12.2431L8.00045 8.94327L4.70063 12.2431L3.75781 11.3003L7.05765 8.00047L3.75781 4.70062L4.70063 3.75781L8.00045 7.05767Z" fill={sleeping ? "rgba(255,255,255,0.6)" : "#111111"} fillOpacity={sleeping ? 1 : 0.6}/>
    </svg>
  );
}

function StripeLogo() {
  const sleeping = useContext(SleepCtx);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="24" viewBox="0 0 40 24" fill="none">
      <path d="M10.3125 5.3125V7.75H12.375V10.0625H10.3125V14.0625C10.3125 15.6875 12.0625 15.1875 12.375 15V17.125C12 17.3125 11.375 17.5 10.4375 17.5C8.8125 17.5 7.5625 16.4375 7.5625 14.8125V5.875L10.3125 5.3125ZM15.875 8.5625C16.5 7.375 17.8125 7.625 18.1875 7.75V10.25C17.8125 10.1875 16.6875 10 16.0625 10.875V17.3125H13.3125V7.75H15.6875L15.875 8.5625ZM21.625 4V6.3125L18.8125 6.875V4.625L21.625 4ZM2.75 10.5625C2.75 11.8125 7 11.1875 7 14.5C7 16.5 5.4375 17.5 3.125 17.5C2.1875 17.5 1.125 17.3125 0.125 16.875V14.375C1 14.875 2.1875 15.25 3.125 15.25C3.75 15.25 4.1875 15.0625 4.1875 14.5625C4.1875 13.25 0 13.75 0 10.6875C0 8.6875 1.5 7.5625 3.75 7.5625C4.625 7.5625 5.5625 7.6875 6.5 8.0625V10.625C5.625 10.1875 4.5625 9.9375 3.75 9.9375C3.125 9.9375 2.75 10.125 2.75 10.5625ZM40 12.625C40 12.875 39.9375 13.5 39.9375 13.625H34.5C34.625 14.9375 35.5625 15.3125 36.6875 15.3125C37.75 15.3125 38.625 15.0625 39.375 14.6875V16.75C38.625 17.1875 37.625 17.5 36.3125 17.5C33.625 17.5 31.6875 15.9375 31.6875 12.625C31.6875 9.8125 33.3125 7.5625 35.9375 7.5625C38.625 7.5625 40 9.8125 40 12.625ZM34.5 11.5625H37.375C37.375 10.3125 36.625 9.8125 35.9375 9.8125C35.25 9.8125 34.5 10.3125 34.5 11.5625ZM27.4375 7.5625C29.375 7.5625 31.1875 9.3125 31.1875 12.5C31.1875 16.0625 29.375 17.5 27.375 17.5C26.4375 17.5 25.8125 17.0625 25.4375 16.8125V19.9375L22.6875 20.5V7.75H25.125L25.25 8.4375C25.625 8.0625 26.3125 7.5625 27.4375 7.5625ZM26.75 15.1875C27.8125 15.1875 28.5 14.0625 28.5 12.5625C28.5 11.125 27.75 10 26.75 10C26.125 10 25.75 10.25 25.4375 10.5625V14.6875C25.75 14.9375 26.125 15.1875 26.75 15.1875ZM18.8125 17.3125V7.75H21.625V17.3125H18.8125Z" fill={sleeping ? "#FFFFFF"  : "#111111"} fillOpacity={sleeping ? 0.25 : 0.4}/>
    </svg>
  );
}

// ── Insights chart (recharts) ─────────────────────────────────────────────────
function CustomTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const orders = payload.find(p => p.dataKey === "value");
  const perDay  = payload.find(p => p.dataKey === "perWorkday");
  return (
    <div style={{
      background: "#171717", borderRadius: "8px", padding: "7px 12px",
      fontFamily: "DM Sans", fontSize: "13px", fontWeight: "600", color: "white",
      pointerEvents: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      whiteSpace: "nowrap", display: "flex", flexDirection: "column", gap: "2px",
    }}>
      {orders && <span>{orders.value} orders</span>}
      {perDay  && <span style={{ color: "#34d399", fontWeight: 500 }}>{perDay.value} / workday</span>}
    </div>
  );
}

function InsightsChart({ data }) {
  const sleeping = useContext(SleepCtx);
  if (!data || data.length < 2) return null;
  const avg = Math.round(data.reduce((s, d) => s + d.value, 0) / data.length);
  return (
    <ResponsiveContainer width="100%" height={180}>
      <ComposedChart data={data} margin={{ top: 16, right: 20, left: 20, bottom: 0 }}>
        <defs>
          <linearGradient id="insightsFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#6C48D8" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#6C48D8" stopOpacity="0.01" />
          </linearGradient>
        </defs>
        <CartesianGrid stroke={sleeping ? "rgba(255,255,255,0.07)" : "#EBEBEB"} strokeWidth={1} />
        <XAxis
          dataKey="label"
          tick={{ fontFamily: "DM Sans", fontSize: 10, fill: "#BBB" }}
          axisLine={false}
          tickLine={false}
          interval={0}
        />
        <YAxis yAxisId="left"  hide={true} />
        <YAxis yAxisId="right" hide={true} orientation="right" />
        <Tooltip content={<CustomTooltip />} cursor={false} />
        <ReferenceLine
          yAxisId="left"
          y={avg}
          stroke="#6C48D8"
          strokeDasharray="4 4"
          strokeOpacity={0.4}
          strokeWidth={1}
          label={{
            value: `avg ${avg.toLocaleString()}`,
            position: "insideTopRight",
            fontSize: 10,
            fontFamily: "DM Sans",
            fill: "rgba(108,72,216,0.6)",
            dy: -6,
          }}
        />
        <Area
          yAxisId="left"
          type="monotone"
          dataKey="value"
          stroke="#6C48D8"
          strokeWidth={2}
          fill="url(#insightsFill)"
          dot={false}
          activeDot={{ r: 5, fill: "#6C48D8", stroke: "#FFF", strokeWidth: 1.5 }}
          isAnimationActive={true}
          animationDuration={900}
          animationEasing="ease-out"
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="perWorkday"
          stroke="#34d399"
          strokeWidth={1.5}
          strokeDasharray="4 3"
          dot={false}
          activeDot={{ r: 4, fill: "#34d399", stroke: "#FFF", strokeWidth: 1.5 }}
          isAnimationActive={true}
          animationDuration={900}
          animationEasing="ease-out"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

// ── Layout helpers ────────────────────────────────────────────────────────────
function SectionCard({ children, style }) {
  const sleeping = useContext(SleepCtx);
  const phone = useContext(PhoneCtx);
  return (
    <div style={{ border: `1px solid ${sleeping ? sl.cardBorder : "#EBEBEB"}`, borderRadius: "14px", padding: phone ? "20px" : "32px", marginBottom: "8px", background: sleeping ? sl.cardBg : "#FFFFFF", width: "100%", boxSizing: "border-box", ...style }}>
      {children}
    </div>
  );
}

function SectionHeader({ icon, title, right }) {
  const sleeping = useContext(SleepCtx);
  const phone = useContext(PhoneCtx);
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: phone ? "8px" : undefined, marginBottom: phone ? "20px" : "32px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {icon}
        <span style={{ fontSize: "20px", fontWeight: "500", color: sleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans", fontStyle: "normal", lineHeight: "20px", letterSpacing: "-0.4px" }}>{title}</span>
      </div>
      {right}
    </div>
  );
}

function OutlineButton({ onClick, children, style, className, disabled }) {
  const sleeping = useContext(SleepCtx);
  return (
    <button className={className || "as-btn-outline"} onClick={onClick} disabled={disabled}
      style={{ width: "100%", height: "36px", padding: "0 12px", borderRadius: "4px", border: `1px solid ${sleeping ? sl.btnBorder : "rgba(17,17,17,0.10)"}`, background: sleeping ? sl.btnBg : "#FFF", boxShadow: sleeping ? "none" : "0 2px 4px 0 rgba(0,0,0,0.04)", fontSize: "14px", fontWeight: "500", fontFamily: "DM Sans", fontStyle: "normal", lineHeight: "16px", color: sleeping ? sl.textPrimary : "#111", cursor: disabled ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", transition: "background 0.15s", opacity: disabled ? 0.6 : 1, boxSizing: "border-box", ...style }}>
      {children}
    </button>
  );
}

function ToggleSwitch({ checked, onChange, label }) {
  const sleeping = useContext(SleepCtx);
  return (
    <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={onChange}
      style={{ width: "40px", height: "24px", padding: 0, flexShrink: 0, border: "none", borderRadius: "100px", cursor: "pointer", position: "relative", background: checked ? "#6C44D4" : (sleeping ? "rgba(255,255,255,0.14)" : "#E0E0E0"), transition: "background 0.15s" }}>
      <span style={{ position: "absolute", top: "3px", left: checked ? "19px" : "3px", width: "18px", height: "18px", borderRadius: "50%", background: "#FFF", boxShadow: "0 1px 2px rgba(0,0,0,0.25)", transition: "left 0.15s" }} />
    </button>
  );
}

function AlertBox({ type, children }) {
  const ok = type === "success";
  return (
    <div style={{ background: ok ? "#F0FBF0" : "#FFF0F3", border: `1px solid ${ok ? "#BBEFBB" : "#FFCDD6"}`, borderRadius: "8px", padding: "10px 14px", fontSize: "13px", color: ok ? "#2E7D32" : "#E91D51", fontWeight: "500", fontFamily: "DM Sans" }}>
      {children}
    </div>
  );
}

function PasswordField({ placeholder, value, onChange, show, onToggle }) {
  const sleeping = useContext(SleepCtx);
  return (
    <div style={{ position: "relative" }}>
      <input className="as-input" type={show ? "text" : "password"} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} autoComplete="new-password"
        style={{ width: "100%", padding: "11px 42px 11px 14px", border: `1px solid ${sleeping ? sl.inputBorder : "#E0E0E0"}`, borderRadius: "10px", fontFamily: "DM Sans", fontSize: "14px", color: sleeping ? sl.textPrimary : "#111", background: sleeping ? sl.inputBg : "white", boxSizing: "border-box", transition: "border-color 0.15s", opacity: value ? 1 : 0.6 }} />
      <button type="button" className="as-pw-toggle" onClick={onToggle} tabIndex={-1}
        style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, color: sleeping ? "rgba(255,255,255,0.3)" : "#BBB", display: "flex", alignItems: "center", transition: "color 0.15s" }}>
        {/* Zelfde oogjes als op het loginscherm */}
        {show ? <VisibilityOutlinedIcon fontSize="small" /> : <VisibilityOffOutlinedIcon fontSize="small" />}
      </button>
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function AccountSettings({ onClose, isSleeping = false, videoPaused, onVideoPausedChange, highlightPaused, onHighlightPausedChange, warningsHidden, onWarningsHiddenChange }) {
  const [open, setOpen] = useState(false);
  const { isPhone } = useMobile();

  useEffect(() => {
    const t = requestAnimationFrame(() => setOpen(true));
    return () => cancelAnimationFrame(t);
  }, []);

  const loopRef = useRef(null);
  useEffect(() => {
    if (!["Admin", "SuperAdmin"].includes(localStorage.getItem("role"))) return;
    loopRef.current = new CadmusLoop(140);
    loopRef.current.start();
    return () => loopRef.current?.stop();
  }, []);

  const handleClose = () => {
    setOpen(false);
    setTimeout(onClose, 300);
  };

  const role           = localStorage.getItem("role");
  const email          = localStorage.getItem("email")          || "user@example.com";
  const company        = localStorage.getItem("company")        || "";
  const orgId          = localStorage.getItem("organization_id");
  const companyDisplay = company.endsWith(".") ? company.slice(0, -1) : company;

  // ── SuperAdmin: organization switcher ─────────────────────────────────────
  const isSuperAdmin    = role === "SuperAdmin";
  const isImpersonating = localStorage.getItem("impersonating") === "true";
  const showOrgSwitcher = isSuperAdmin || isImpersonating;
  const realCompany     = localStorage.getItem("real_company") || "";

  const [orgList,     setOrgList]     = useState([]);
  const [orgLoading,  setOrgLoading]  = useState(false);
  const [orgSearch,   setOrgSearch]   = useState("");
  const [orgListOpen, setOrgListOpen] = useState(false);
  const [switching,   setSwitching]   = useState(false);
  const [switchError, setSwitchError] = useState("");

  useEffect(() => {
    if (!showOrgSwitcher) return;
    setOrgLoading(true);
    apiClient.get("/admin/organizations")
      .then(r => setOrgList(Array.isArray(r.data) ? r.data : []))
      .catch(() => setOrgList([]))
      .finally(() => setOrgLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOrgSwitcher]);

  const handleSwitchOrganization = async (targetOrgId) => {
    setSwitching(true);
    setSwitchError("");
    try {
      const r = await apiClient.post("/admin/switch-organization", { organizationId: targetOrgId });
      const d = r.data;

      if (d.impersonating) {
        if (!isImpersonating) {
          localStorage.setItem("real_organization_id", orgId   || "");
          localStorage.setItem("real_company",         company || "");
          localStorage.setItem("real_role",             role    || "");
        }
        localStorage.setItem("impersonating", "true");
      } else {
        localStorage.removeItem("impersonating");
        localStorage.removeItem("real_organization_id");
        localStorage.removeItem("real_company");
        localStorage.removeItem("real_role");
      }

      localStorage.setItem("token",           d.token);
      localStorage.setItem("organization_id", String(d.organization_id));
      localStorage.setItem("company",         d.company  || "");
      localStorage.setItem("org_type",        d.org_type || "");
      localStorage.setItem("role",            d.role     || "");
      localStorage.setItem("multicompany",    d.multicompany ? "true" : "false");

      window.location.reload();
    } catch (err) {
      setSwitchError(err.response?.data?.message || "Failed to switch organization.");
      setSwitching(false);
    }
  };

  const filteredOrgList = orgList.filter(o =>
    (o.name || "").toLowerCase().includes(orgSearch.toLowerCase())
  );

  // ── Password state ────────────────────────────────────────────────────────
  const [currentPassword,  setCurrentPassword]  = useState("");
  const [newPassword,      setNewPassword]       = useState("");
  const [confirmPassword,  setConfirmPassword]   = useState("");
  const [showPasswordForm, setShowPasswordForm]  = useState(false);
  const [showCurrent,      setShowCurrent]       = useState(false);
  const [showNew,          setShowNew]           = useState(false);
  const [showConfirm,      setShowConfirm]       = useState(false);
  const [pwLoading,        setPwLoading]         = useState(false);
  const [pwError,          setPwError]           = useState("");
  const [pwSuccess,        setPwSuccess]         = useState(false);

  const handleUpdatePassword = async () => {
    setPwError("");
    if (!currentPassword || !newPassword || !confirmPassword) { setPwError("All fields are required."); return; }
    if (newPassword.length < 8)          { setPwError("New password must be at least 8 characters."); return; }
    if (newPassword !== confirmPassword) { setPwError("New passwords do not match."); return; }
    setPwLoading(true);
    try {
      await apiClient.post("/update-password", { current_password: currentPassword, new_password: newPassword });
      setPwSuccess(true);
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
      setTimeout(() => { setPwSuccess(false); setShowPasswordForm(false); }, 2000);
    } catch (err) {
      setPwError(err.response?.data?.message || "Failed to update password. Please try again.");
    } finally { setPwLoading(false); }
  };

  // ── Stripe ────────────────────────────────────────────────────────────────
  const handleStripePortal = async () => {
    try {
      const r = await apiClient.get("/stripe-portal");
      if (r?.data?.url) window.open(r.data.url, "_blank");
    } catch (err) { console.error("Stripe portal error:", err); }
  };

  // ── API Tokens state ──────────────────────────────────────────────────────
  const [tokens,            setTokens]            = useState([]);
  const [tokenLoading,      setTokenLoading]      = useState(true);
  const [showNewTokenInput, setShowNewTokenInput] = useState(false);
  const [newTokenName,      setNewTokenName]      = useState("");
  const [creatingToken,     setCreatingToken]     = useState(false);
  const [editingTokenId,    setEditingTokenId]    = useState(null);
  const [editingTokenName,  setEditingTokenName]  = useState("");
  const [copiedId,          setCopiedId]          = useState(null);
  const [newlyCreatedToken, setNewlyCreatedToken] = useState(null);

  useEffect(() => {
    apiClient.get("/api-tokens", { params: { organization_id: orgId } })
      .then(r => setTokens(Array.isArray(r.data) ? r.data : []))
      .catch(() => setTokens([]))
      .finally(() => setTokenLoading(false));
  }, [orgId]);

  const handleCreateToken = async () => {
    if (!newTokenName.trim()) return;
    setCreatingToken(true);
    try {
      const r = await apiClient.post("/api-tokens", { organization_id: orgId, name: newTokenName.trim() });
      setTokens(prev => [...prev, r.data]);
      setNewlyCreatedToken(r.data);
      setNewTokenName("");
      setShowNewTokenInput(false);
    } catch (err) { console.error(err); }
    finally { setCreatingToken(false); }
  };

  const handleDeleteToken = async (id) => {
    try {
      await apiClient.delete(`/api-tokens/${id}`);
      setTokens(prev => prev.filter(t => t.id !== id));
    } catch (err) { console.error(err); }
  };

  const handleRenameToken = async (id) => {
    if (!editingTokenName.trim()) return;
    try {
      await apiClient.patch(`/api-tokens/${id}`, { name: editingTokenName.trim() });
      setTokens(prev => prev.map(t => t.id === id ? { ...t, name: editingTokenName.trim() } : t));
      setEditingTokenId(null);
    } catch (err) { console.error(err); }
  };

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 1500);
    });
  };

  // ── Insights state ────────────────────────────────────────────────────────
  const [chartData,    setChartData]    = useState([]);
  const [chartLoading, setChartLoading] = useState(true);
  const [exporting,    setExporting]    = useState(false);

  useEffect(() => {
    if (!orgId) return;
    apiClient.get("/insights", { params: { organization_id: orgId, period: "6m" } })
      .then(r => {
        const raw = Array.isArray(r.data) ? r.data : [];
        setChartData(raw.map(d => ({ label: d.label, value: d.value, perWorkday: d.perWorkday })));
      })
      .catch(err => {
        console.error("[Insights] Failed to load chart data:", err);
        setChartData([]);
      })
      .finally(() => setChartLoading(false));
  }, [orgId]);

  const handleExportInsights = async () => {
    setExporting(true);
    try {
      const r = await apiClient.get("/insights/export", { params: { organization_id: orgId }, responseType: "blob" });
      const filename = `cadmus_insights_${new Date().toISOString().slice(0, 10)}.csv`;
      const csvText = await r.data.text();
      const url = URL.createObjectURL(new Blob(["\uFEFF", "sep=,\n", csvText], { type: "text/csv;charset=utf-8;" }));
      const a   = document.createElement("a");
      a.href = url; a.download = filename; a.click();
      URL.revokeObjectURL(url);
    } catch (err) { console.error("Export error:", err); }
    finally { setExporting(false); }
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <SleepCtx.Provider value={isSleeping}>
    <PhoneCtx.Provider value={isPhone}>
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      transitionDuration={300}
      PaperProps={{
        className: "as-drawer-paper",
        sx: {
          width: 480,
          padding: "0px 8px 32px 8px",
          // Telefoon: schermvullend, met ruimte voor notch en home-indicator
          ...(isPhone && {
            width: "100%",
            padding: "env(safe-area-inset-top, 0px) 8px calc(env(safe-area-inset-bottom, 0px) + 24px) 8px",
            boxSizing: "border-box",
          }),
          fontFamily: '"DM Sans", sans-serif',
          overflowX: "hidden",
          background: isSleeping ? sl.drawerBg : "#FAFAF9",
          border: "1px solid rgba(255,255,255,0.20)",
          borderTopLeftRadius: "40px !important",
          borderTopRightRadius: "0px !important",
          borderBottomLeftRadius: "0px !important",
          borderBottomRightRadius: "0px !important",
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          transition: "background 1.5s ease",
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(4px)", background: "rgba(0,0,0,0.35)" },
      }}
    >
      <style>{`
        .as-btn-outline:hover  { background: ${isSleeping ? "rgba(255,255,255,0.12)" : "#f5f5f5"} !important; }
        .as-close-btn:hover    { background: ${isSleeping ? "rgba(255,255,255,0.12)" : "rgba(17,17,17,0.10)"} !important; }
        .as-btn-primary:hover  { background: #5a35c0 !important; }
        .as-btn-stripe:hover   { background: ${isSleeping ? "rgba(255,255,255,0.12)" : "#f0f0f0"} !important; }
        .as-pw-toggle:hover    { color: #6C44D4 !important; }
        .as-input:focus        { border-color: #6C44D4 !important; outline: none; }
        .as-icon-btn:hover     { background: ${isSleeping ? "rgba(255,255,255,0.10)" : "#F5F2FF"} !important; }
        .as-icon-btn-del:hover { background: ${isSleeping ? "rgba(255,80,80,0.15)" : "#FFF0F3"} !important; }
        .as-drawer-paper { border-radius: ${isPhone ? "0" : "40px 0 0 0"} !important; }
        ${isPhone ? ".as-drawer-paper input { font-size: 16px !important; } /* iOS zoomt anders in bij focus */" : ""}
        .as-drawer-paper * { letter-spacing: 0 !important; }
      `}</style>

      {/* Close button — fixed, outside scroll container */}
      <button onClick={handleClose} className="as-close-btn" style={{ position: "fixed", top: isPhone ? "calc(env(safe-area-inset-top, 0px) + 8px)" : "8px", right: "8px", width: "48px", height: "48px", borderRadius: "100px", border: `1px solid ${isSleeping ? sl.btnBorder : "rgba(17,17,17,0.10)"}`, background: isSleeping ? sl.btnBg : "rgba(17,17,17,0.05)", backdropFilter: "blur(4px)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px", boxSizing: "border-box", zIndex: 1400 }}>
        <CloseIcon />
      </button>

      <div style={{ width: "100%", position: "relative", paddingTop: "0px", paddingBottom: "16px" }}>

      {/* Header */}
      <h2 style={{ margin: "0 0 8px", paddingTop: isPhone ? "64px" : "40px", paddingLeft: isPhone ? "16px" : "32px", fontSize: isPhone ? "30px" : "40px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", letterSpacing: "0", lineHeight: isPhone ? "34px" : "40px", fontFamily: "DM Sans", fontStyle: "normal" }}>
        Account Settings
      </h2>
      <p style={{ margin: "0 0 16px", paddingLeft: isPhone ? "16px" : "32px", width: isPhone ? "auto" : "360px", paddingRight: isPhone ? "16px" : undefined, fontSize: "14px", color: isSleeping ? sl.textSecond : "#888", lineHeight: 1.5, fontFamily: "DM Sans" }}>
        Dive into your account settings to easily tweak your details and payment options.
      </p>

      {/* ── SuperAdmin: organization switcher ─────────────────────────────── */}
      {isImpersonating && (
        <SectionCard style={{ background: "#6C48D8", border: "none" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
            <div style={{ minWidth: 0 }}>
              <span style={{ display: "block", fontSize: "11px", fontWeight: "700", color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: "0.08em", fontFamily: "DM Sans" }}>Viewing as</span>
              <span style={{ display: "block", fontSize: "16px", fontWeight: "600", color: "white", fontFamily: "DM Sans", marginTop: "2px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{companyDisplay}</span>
            </div>
            <button onClick={() => handleSwitchOrganization(parseInt(localStorage.getItem("real_organization_id"), 10))} disabled={switching}
              style={{ flexShrink: 0, padding: "9px 14px", border: "1px solid rgba(255,255,255,0.4)", borderRadius: "10px", background: "rgba(255,255,255,0.12)", fontSize: "13px", fontWeight: "600", color: "white", cursor: switching ? "not-allowed" : "pointer", fontFamily: "DM Sans", opacity: switching ? 0.7 : 1 }}>
              {switching ? "…" : `Return to ${realCompany || "my account"}`}
            </button>
          </div>
        </SectionCard>
      )}

      {showOrgSwitcher && (
        <SectionCard style={{ position: "relative", overflow: "visible" }}>
          <SectionHeader icon={<SwitchOrgIcon />} title="Switch organization" />

          <span style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.40)", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px", display: "block", marginBottom: "10px" }}>
            Jump into any organization or group to quickly check things.
          </span>

          {switchError && <div style={{ marginBottom: "10px" }}><AlertBox type="error">{switchError}</AlertBox></div>}

          <div style={{ position: "relative" }}>
            <input
              className="as-input"
              value={orgSearch}
              onChange={e => { setOrgSearch(e.target.value); setOrgListOpen(true); }}
              onFocus={() => setOrgListOpen(true)}
              onBlur={() => setTimeout(() => setOrgListOpen(false), 150)}
              placeholder={orgLoading ? "Loading organizations…" : "Search organizations…"}
              disabled={switching}
              style={{ width: "100%", padding: "11px 14px", border: `1px solid ${isSleeping ? sl.inputBorder : "#E0E0E0"}`, borderRadius: "10px", fontFamily: "DM Sans", fontSize: "14px", color: isSleeping ? sl.textPrimary : "#111", background: isSleeping ? sl.inputBg : "white", boxSizing: "border-box" }}
            />

            {orgListOpen && !orgLoading && (
              <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, maxHeight: "260px", overflowY: "auto", background: isSleeping ? "#1A1A1A" : "white", border: `1px solid ${isSleeping ? sl.inputBorder : "#E0E0E0"}`, borderRadius: "10px", boxShadow: "0 8px 24px rgba(0,0,0,0.18)", zIndex: 1500 }}>
                {filteredOrgList.length === 0 ? (
                  <div style={{ padding: "12px 14px", fontSize: "13px", color: "#999", fontFamily: "DM Sans" }}>No organizations found.</div>
                ) : filteredOrgList.map(org => {
                  const isCurrent = String(org.id) === String(orgId);
                  return (
                    <button
                      key={org.id}
                      disabled={isCurrent || switching}
                      onMouseDown={e => e.preventDefault()}
                      onClick={() => { setOrgListOpen(false); setOrgSearch(""); handleSwitchOrganization(org.id); }}
                      style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", padding: "10px 14px", border: "none", borderBottom: `1px solid ${isSleeping ? sl.separator : "#F5F5F5"}`, background: "none", cursor: isCurrent ? "default" : "pointer", textAlign: "left", fontFamily: "DM Sans" }}
                    >
                      <span style={{ fontSize: "13px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{org.name}</span>
                      <span style={{ flexShrink: 0, display: "flex", alignItems: "center", gap: "6px" }}>
                        {isCurrent && <span style={{ fontSize: "10px", fontWeight: "700", color: "#6C48D8", textTransform: "uppercase", letterSpacing: "0.05em" }}>Current</span>}
                        <span style={{ fontSize: "10px", fontWeight: "600", color: isSleeping ? sl.textSecond : "#888", background: isSleeping ? sl.btnBg : "#F5F5F5", borderRadius: "5px", padding: "3px 7px", textTransform: "uppercase", letterSpacing: "0.05em" }}>{org.type}</span>
                      </span>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </SectionCard>
      )}

      {/* ── Credentials ────────────────────────────────────────────────────── */}
      <SectionCard>
        <SectionHeader
          icon={<CredentialsIcon />}
          title="Credentials"
          right={companyDisplay && (
            <span style={{ fontSize: "11px", fontWeight: "600", color: isSleeping ? sl.textSecond : "#888", textTransform: "uppercase", letterSpacing: "0.08em", background: isSleeping ? sl.btnBg : "#F5F5F5", borderRadius: "6px", padding: "4px 8px", fontFamily: "DM Sans" }}>
              {companyDisplay}
            </span>
          )}
        />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px" }}>
          <span style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.40)", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px" }}>Logged in as</span>
          <span style={{ fontSize: "13px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans" }}>{email}</span>
        </div>

        {!showPasswordForm ? (
          <OutlineButton onClick={() => setShowPasswordForm(true)}>Update password</OutlineButton>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {pwSuccess && <AlertBox type="success">✓ Password updated successfully.</AlertBox>}
            {pwError   && <AlertBox type="error">{pwError}</AlertBox>}
            <PasswordField placeholder="Current password"     value={currentPassword} onChange={setCurrentPassword} show={showCurrent} onToggle={() => setShowCurrent(p => !p)} />
            <PasswordField placeholder="New password"         value={newPassword}     onChange={setNewPassword}     show={showNew}     onToggle={() => setShowNew(p => !p)} />
            <PasswordField placeholder="Confirm new password" value={confirmPassword} onChange={setConfirmPassword} show={showConfirm} onToggle={() => setShowConfirm(p => !p)} />
            <div style={{ display: "flex", gap: "8px", marginTop: "4px" }}>
              <button className="as-btn-outline" onClick={() => { setShowPasswordForm(false); setPwError(""); setCurrentPassword(""); setNewPassword(""); setConfirmPassword(""); }}
                style={{ flex: 1, padding: "11px", border: `1px solid ${isSleeping ? sl.btnBorder : "#E0E0E0"}`, borderRadius: "10px", background: isSleeping ? sl.btnBg : "white", fontSize: "14px", fontWeight: "500", color: isSleeping ? sl.textSecond : "#666", cursor: "pointer", fontFamily: "DM Sans", transition: "background 0.15s" }}>
                Cancel
              </button>
              <button className="as-btn-primary" onClick={handleUpdatePassword} disabled={pwLoading}
                style={{ flex: 2, padding: "11px", border: "none", borderRadius: "10px", background: "#6C44D4", fontSize: "14px", fontWeight: "600", color: "white", cursor: pwLoading ? "not-allowed" : "pointer", opacity: pwLoading ? 0.7 : 1, fontFamily: "DM Sans", transition: "background 0.15s" }}>
                {pwLoading ? "Updating…" : "Save password"}
              </button>
            </div>
          </div>
        )}
      </SectionCard>

      {/* ── Insights ────────────────────────────────────────────────────────── */}
      <SectionCard>
        <SectionHeader icon={<InsightsIcon />} title="Insights" />

        <span style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.40)", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px", display: "block", marginBottom: "16px" }}>
          Last 6 months
        </span>

        {chartLoading ? (
          <div style={{ height: "130px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontSize: "13px", color: "#CCC", fontFamily: "DM Sans" }}>Loading…</span>
          </div>
        ) : (
          <InsightsChart data={chartData} />
        )}

        <div style={{ marginTop: "8px" }}>
          <OutlineButton onClick={handleExportInsights} disabled={exporting}>
            {exporting ? "Exporting…" : "Export Insights"}
          </OutlineButton>
        </div>
      </SectionCard>

      {/* ── Payment Method ──────────────────────────────────────────────────── */}
      {SHOW_PAYMENT_AND_TOKENS && ["Admin", "SuperAdmin"].includes(localStorage.getItem("role")) && <SectionCard>
        <SectionHeader
          icon={<PaymentIcon />}
          title="Payment method"
          right={
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ fontSize: "11px", color: "#AAA", fontWeight: "500", fontFamily: "DM Sans" }}>Powered by</span>
              <StripeLogo />
            </div>
          }
        />

        <div style={{ marginBottom: "16px" }}>
          <span style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.40)", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px", display: "block", marginBottom: "16px" }}>Current subscription</span>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", borderBottom: `1px solid ${isSleeping ? sl.separator : "#F0F0F0"}` }}>
            <span style={{ fontSize: "14px", fontWeight: "600", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans" }}>Cadmus Pay As You Go</span>
            <span style={{ fontSize: "13px", color: isSleeping ? sl.textSecond : "#888", fontFamily: "DM Sans" }}>€1.25 / order</span>
          </div>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <span style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.40)", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px", display: "block", marginBottom: "16px" }}>Payment method</span>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ background: "#1A1F71", borderRadius: "4px", padding: "3px 6px", fontSize: "10px", fontWeight: "900", color: "white", letterSpacing: "-0.3px", fontStyle: "italic" }}>VISA</div>
              <span style={{ fontSize: "13px", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans" }}>•••• 4242</span>
              <span style={{ background: "#E8F5E9", color: "#2E7D32", fontSize: "10px", fontWeight: "700", borderRadius: "5px", padding: "2px 7px", textTransform: "uppercase", letterSpacing: "0.05em", fontFamily: "DM Sans" }}>ACTIVE</span>
            </div>
            <span style={{ fontSize: "12px", color: "#AAA", fontFamily: "DM Sans" }}>Expires 02/2027</span>
          </div>
        </div>

        <p style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.60)", textAlign: "center", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "150%", margin: "0 0 16px" }}>
          Cadmus is using Stripe for secure payments. Visit the Stripe Customer Portal to update your payment method, change billing information or see your invoice history.
        </p>

        <OutlineButton className="as-btn-stripe" onClick={handleStripePortal}>
          Visit Stripe Customer Portal
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 10L10 2M10 2H4.5M10 2V7.5" stroke={isSleeping ? "rgba(255,255,255,0.7)" : "#111"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </OutlineButton>
      </SectionCard>}

      {/* ── API Tokens ──────────────────────────────────────────────────────── */}
      {SHOW_PAYMENT_AND_TOKENS && ["Admin", "SuperAdmin"].includes(localStorage.getItem("role")) && <SectionCard>
        <SectionHeader icon={<ApiTokenIcon />} title="API Tokens" />

        <span style={{ color: isSleeping ? sl.textSecond : "rgba(17,17,17,0.40)", fontFamily: "DM Sans", fontSize: "14px", fontStyle: "normal", fontWeight: "500", lineHeight: "16px", display: "block", marginBottom: "10px" }}>
          Active API Tokens
        </span>

        {tokenLoading ? (
          <div style={{ fontSize: "13px", color: "#CCC", fontFamily: "DM Sans", padding: "8px 0" }}>Loading…</div>
        ) : tokens.length === 0 && !showNewTokenInput ? (
          <div style={{ fontSize: "13px", color: "#CCC", fontFamily: "DM Sans", padding: "8px 0" }}>No tokens yet.</div>
        ) : (
          <div>
            {tokens.map((token, i) => (
              <div key={token.id}>
                {i > 0 && <div style={{ borderTop: `1px solid ${isSleeping ? sl.separator : "#F5F5F5"}` }} />}
                {editingTokenId === token.id ? (
                  <div style={{ display: "flex", gap: "8px", alignItems: "center", padding: "10px 0" }}>
                    <input autoFocus value={editingTokenName} onChange={e => setEditingTokenName(e.target.value)}
                      onKeyDown={e => { if (e.key === "Enter") handleRenameToken(token.id); if (e.key === "Escape") setEditingTokenId(null); }}
                      style={{ flex: 1, padding: "7px 10px", border: "1px solid #6C44D4", borderRadius: "8px", fontFamily: "DM Sans", fontSize: "13px", color: isSleeping ? sl.textPrimary : "#111", background: isSleeping ? sl.inputBg : "white", outline: "none" }} />
                    <button onClick={() => handleRenameToken(token.id)}
                      style={{ padding: "7px 12px", border: "none", borderRadius: "8px", background: "#6C44D4", color: "white", fontSize: "12px", fontWeight: "600", cursor: "pointer", fontFamily: "DM Sans" }}>
                      Save
                    </button>
                    <button onClick={() => setEditingTokenId(null)}
                      style={{ padding: "7px 10px", border: `1px solid ${isSleeping ? sl.btnBorder : "#E0E0E0"}`, borderRadius: "8px", background: isSleeping ? sl.btnBg : "white", fontSize: "12px", cursor: "pointer", fontFamily: "DM Sans", color: isSleeping ? sl.textSecond : "#666" }}>
                      ✕
                    </button>
                  </div>
                ) : (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 0" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px", flex: 1, minWidth: 0 }}>
                      <span style={{ fontSize: "13px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans", whiteSpace: "nowrap" }}>{token.name}</span>
                      <span style={{ fontSize: "13px", color: "#CCC" }}>•</span>
                      <span style={{ fontSize: "12px", color: "#999", fontFamily: "monospace", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {(token.token || token.value || token.key || "").slice(0, 8)}…
                      </span>
                      <button className="as-icon-btn" title={copiedId === token.id ? "Copied!" : "Copy"} onClick={() => handleCopy(token.token || token.value || token.key || "", token.id)}
                        style={{ background: "none", border: "none", cursor: "pointer", padding: "3px", borderRadius: "5px", display: "flex", alignItems: "center", transition: "background 0.15s", flexShrink: 0 }}>
                        {copiedId === token.id ? (
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6C44D4" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                        ) : (
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#CCC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                          </svg>
                        )}
                      </button>
                    </div>
                    <div style={{ display: "flex", gap: "2px", flexShrink: 0 }}>
                      <button className="as-icon-btn" onClick={() => { setEditingTokenId(token.id); setEditingTokenName(token.name); }}
                        style={{ background: "none", border: "none", cursor: "pointer", padding: "6px", borderRadius: "8px", display: "flex", alignItems: "center", transition: "background 0.15s" }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#AAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                      </button>
                      <button className="as-icon-btn-del" onClick={() => handleDeleteToken(token.id)}
                        style={{ background: "none", border: "none", cursor: "pointer", padding: "6px", borderRadius: "8px", display: "flex", alignItems: "center", transition: "background 0.15s" }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#CCC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                          <path d="M10 11v6M14 11v6" /><path d="M9 6V4h6v2" />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {newlyCreatedToken && (
          <div style={{ margin: "12px 0", background: isSleeping ? "rgba(108,72,216,0.12)" : "#F5F2FF", border: `1px solid ${isSleeping ? "rgba(108,72,216,0.3)" : "#DDD6FF"}`, borderRadius: "10px", padding: "12px 14px" }}>
            <div style={{ fontSize: "12px", fontWeight: "600", color: "#8B6BE0", marginBottom: "8px", fontFamily: "DM Sans" }}>
              Token created — copy it now, it won't be shown again.
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <code style={{ fontSize: "11px", color: isSleeping ? "rgba(255,255,255,0.7)" : "#333", wordBreak: "break-all", flex: 1, fontFamily: "monospace", lineHeight: 1.5 }}>
                {newlyCreatedToken.token || newlyCreatedToken.value || newlyCreatedToken.key}
              </code>
              <button onClick={() => handleCopy(newlyCreatedToken.token || newlyCreatedToken.value || newlyCreatedToken.key, "new")}
                style={{ flexShrink: 0, padding: "6px 10px", border: "1px solid #6C44D4", borderRadius: "7px", background: isSleeping ? "rgba(108,72,216,0.2)" : "white", fontSize: "12px", color: "#8B6BE0", fontWeight: "600", cursor: "pointer", fontFamily: "DM Sans" }}>
                {copiedId === "new" ? "Copied!" : "Copy"}
              </button>
            </div>
            <button onClick={() => setNewlyCreatedToken(null)} style={{ marginTop: "8px", fontSize: "11px", color: "#AAA", background: "none", border: "none", cursor: "pointer", fontFamily: "DM Sans", padding: 0 }}>
              Dismiss
            </button>
          </div>
        )}

        {showNewTokenInput && (
          <div style={{ display: "flex", gap: "8px", alignItems: "center", marginTop: "14px" }}>
            <input autoFocus value={newTokenName} onChange={e => setNewTokenName(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") handleCreateToken(); if (e.key === "Escape") { setShowNewTokenInput(false); setNewTokenName(""); } }}
              placeholder="Token name (e.g. CRM)"
              style={{ flex: 1, padding: "9px 12px", border: "1px solid #6C44D4", borderRadius: "8px", fontFamily: "DM Sans", fontSize: "13px", color: isSleeping ? sl.textPrimary : "#111", background: isSleeping ? sl.inputBg : "white", outline: "none" }} />
            <button onClick={handleCreateToken} disabled={creatingToken}
              style={{ padding: "9px 14px", border: "none", borderRadius: "8px", background: "#6C44D4", color: "white", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "DM Sans", opacity: creatingToken ? 0.7 : 1 }}>
              {creatingToken ? "…" : "Create"}
            </button>
          </div>
        )}

        <div style={{ marginTop: "16px" }}>
          <OutlineButton onClick={() => { setShowNewTokenInput(p => !p); setNewTokenName(""); }}>
            {showNewTokenInput ? "Cancel" : "Create New Token"}
          </OutlineButton>
        </div>
      </SectionCard>}

      {/* ── Presentation mode (Admin/Demo only) ─────────────────────────────── */}
      {(role === "Admin" || role === "SuperAdmin" || role === "Demo") && (
        <SectionCard>
          <SectionHeader icon={<PresentationIcon />} title="Presentation mode" />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", marginBottom: "16px", borderBottom: `1px solid ${isSleeping ? sl.separator : "#F0F0F0"}` }}>
            <div>
              <span style={{ display: "block", fontSize: "14px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans" }}>Background video</span>
              <span style={{ display: "block", fontSize: "12px", color: isSleeping ? sl.textSecond : "#999", fontFamily: "DM Sans", marginTop: "2px" }}>Pause the looping video behind the dashboard</span>
            </div>
            <ToggleSwitch checked={!videoPaused} onChange={() => onVideoPausedChange?.(p => !p)} label="Toggle background video" />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "16px", marginBottom: "16px", borderBottom: `1px solid ${isSleeping ? sl.separator : "#F0F0F0"}` }}>
            <div>
              <span style={{ display: "block", fontSize: "14px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans" }}>Animated glow</span>
              <span style={{ display: "block", fontSize: "12px", color: isSleeping ? sl.textSecond : "#999", fontFamily: "DM Sans", marginTop: "2px" }}>Freeze the moving highlight glow</span>
            </div>
            <ToggleSwitch checked={!highlightPaused} onChange={() => onHighlightPausedChange?.(p => !p)} label="Toggle animated glow" />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <span style={{ display: "block", fontSize: "14px", fontWeight: "500", color: isSleeping ? sl.textPrimary : "#111", fontFamily: "DM Sans" }}>Dashboard warnings</span>
              <span style={{ display: "block", fontSize: "12px", color: isSleeping ? sl.textSecond : "#999", fontFamily: "DM Sans", marginTop: "2px" }}>Turn the dashboard red when a portal needs attention</span>
            </div>
            <ToggleSwitch checked={!warningsHidden} onChange={() => onWarningsHiddenChange?.(p => !p)} label="Toggle dashboard warnings" />
          </div>
        </SectionCard>
      )}

      {/* Footer */}
      <p style={{ textAlign: "center", fontSize: "14px", color: isSleeping ? sl.textMuted : "rgba(17,17,17,0.60)", fontFamily: "DM Sans", fontStyle: "normal", fontWeight: "400", lineHeight: "150%", margin: "16px 0 0" }}>
        Read our{" "}
        <a href={process.env.REACT_APP_PRODUCT_TERMS_URL} target="_blank" rel="noopener noreferrer" style={{ color: isSleeping ? sl.textSecond : "#111", fontWeight: "500", fontSize: "14px", fontFamily: "DM Sans", lineHeight: "150%", textDecoration: "none" }} onMouseEnter={e => (e.target.style.textDecoration = "underline")} onMouseLeave={e => (e.target.style.textDecoration = "none")}>Product Terms</a>
        {", "}
        <a href={process.env.REACT_APP_DPA_URL} target="_blank" rel="noopener noreferrer" style={{ color: isSleeping ? sl.textSecond : "#111", fontWeight: "500", fontSize: "14px", fontFamily: "DM Sans", lineHeight: "150%", textDecoration: "none" }} onMouseEnter={e => (e.target.style.textDecoration = "underline")} onMouseLeave={e => (e.target.style.textDecoration = "none")}>DPA</a>
        {" "}and{" "}
        <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" style={{ color: isSleeping ? sl.textSecond : "#111", fontWeight: "500", fontSize: "14px", fontFamily: "DM Sans", lineHeight: "150%", textDecoration: "none" }} onMouseEnter={e => (e.target.style.textDecoration = "underline")} onMouseLeave={e => (e.target.style.textDecoration = "none")}>Privacy Policy</a>.
      </p>

      </div>
    </Drawer>
    </PhoneCtx.Provider>
    </SleepCtx.Provider>
  );
}